// @ts-nocheck


import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from '../../lib/routerAdapter';
import { navigate } from '../../lib/routerAdapter';
import qs from 'query-string';
import isEmpty from 'lodash/isEmpty';
import { Popconfirm, Button } from 'antd';
import moment from 'moment';
import { DatePicker } from '../../components/ant/DatePicker';

import { vehicleTypes } from '../../lib/enum';
import {
  formatDateRangeString,
  formatDateTimeToISOString,
  setQueryParams } from
'../../lib/helpers';






import { getListInitialState, applyMaskToValue } from '../../lib/helpers';

import { wialonTripApi, tripDrivingQualityApi, tripApi } from './../../lib/api';
import { Table } from './../../components/ui';
import ButtonsRow from '../../components/ui/ButtonsRow';
import { formatLicensePlateMask } from '../../components/inputs/masked-inputs/LicensePlateInput';
import Filter from './components/Filter';
import { Header } from '../../components/layout';
import Section from '../../components/layout/Section';
import { printNotification } from '../../lib/notificationWrapper';

const DriverRatingContainer = styled.div.withConfig({ displayName: "List__DriverRatingContainer", componentId: "sc-1pktgpc-0" })(["display:flex;flex-direction:row;width:160px;"]);





export const getQualityColor = (quality) => {
  if (quality === 0) return 'black';else
  if (quality > 0 && quality <= 3) return '#f55b5b';else
  if (quality > 3 && quality <= 4.5) return '#f5b05b';else
  return 'green';
};

export const COLUMNS = [
{
  title: '№ Пл',
  dataIndex: 'trip.idNumber',
  sorter: true
},
{
  title: 'Тип',
  dataIndex: 'vehicleType',
  sorter: true,
  render: (vehicleType, record) =>
  record.vehicle ?
  record.vehicle.vehicleModel &&
  vehicleTypes[record.vehicle.vehicleModel.type] :
  vehicleTypes[vehicleType]
},
{
  title: 'Служба использования',
  sorter: true,
  sorterKey: 'node.name',
  dataIndex: 'vehicle.usingNodeName'
},
{
  title: 'Период выделения',
  dataIndex: 'actualTimeAtStart',
  sorterKey: 'actualTimeAtStart',
  sorter: true,
  render: (
  text,
  record) =>

  formatDateRangeString(record.actualTimeAtStart, record.actualTimeAtEnd)
},
{
  title: 'ТС',
  dataIndex: 'vehicle',
  sorter: true,
  // Нужно для того, чтобы не отрабатывал onRow
  onCell: () => ({ onClick: (e) => e.stopPropagation() }),
  render: (vehicle, trip) => {
    if (vehicle) {
      const licensePlate =
      vehicle.licensePlate &&
      applyMaskToValue(vehicle.licensePlate, formatLicensePlateMask);
      if (vehicle.isDeleted) return licensePlate;
      return (
        <Link to={`/vehicles/${trip.vehicleId || ''}`}>{licensePlate}</Link>);

    }
    return null;
  }
},
//Временно скрыто для показа
// {
//   title: 'Пробег по регламенту',
//   dataIndex: 'regulationsDistance',
//   render: (distance: number) => !!distance && `${distance.toFixed(2)} км`
// },
{
  title: 'Пробег по системе',
  dataIndex: 'kilometrage',
  render: (distance) => !!distance && `${distance.toFixed(2)} км`
},
{
  title: 'Оценка качества вождения',
  dataIndex: 'driverRating',
  onCell: () => ({ onClick: (e) => e.stopPropagation() }),
  render: (quality, trip) =>
  <DriverRatingContainer>
        <span style={{ color: getQualityColor(quality), flex: 'auto' }}>
          {quality}
        </span>
        <Button
      type="primary"
      onClick={() =>
      printNotification(
        async () => await tripDrivingQualityApi.print(trip.id)
      )
      }>

          Отчет
        </Button>
      </DriverRatingContainer>

}];

















export default class TripsList extends Component {
  static defaultProps = {
    location: {},
    selectable: true
  };

  state = {
    ...getListInitialState(),
    filter: {},
    print: {},
    printDeviationReport: {}
  };

  handleRowClick = (id) => navigate(`/wialonTrips/${id}`);

  fetchTrips = async (page = 1, params = {}) => {
    this.setState({ loading: true });
    if (isEmpty(params)) {
      params = { orderBy: 'actualTimeAtStart', byDescending: true };
    }
    const { data, totalCount } = await wialonTripApi.fetch({
      ...this.state.filter,
      isArchive: true,
      page,
      ...params
    });
    setQueryParams({ page });
    this.setState({ loading: false, data, totalCount, page });
  };

  cleanFilter = () => this.setState({ filter: {} }, this.fetchTrips);

  applyFilter = (filter) =>
  this.setState({ filter }, this.fetchTrips);

  async componentDidMount() {
    const { page, ...filter } = qs.parse(window.location.search);
    await this.setState({ filter }, async () => await this.fetchTrips(page));
  }

  onConfirmCheck = async (name) => {
    await printNotification(async () => {
      const fetchParams = {
        startDate: formatDateTimeToISOString(
          {},
          moment(this.state[name].startDate).hour(12)
        ),
        endDate: formatDateTimeToISOString(
          {},
          moment(this.state[name].endDate).hour(12)
        )
      };
      switch (name) {
        case 'printDeviationReport':
          await tripApi[name](fetchParams);
          break;
        case 'print':
          await wialonTripApi[name](fetchParams);
          break;
        default:
      }
      this.setState({
        // $FlowFixMe ругается на [name]
        [name]: {
          ...this.state[name],
          startDate: undefined,
          endDate: undefined
        }
      });
    });
  };

  renderPrint = (
  name,
  buttonText) =>
  {
    return (
      <Popconfirm
        title={
        <>
            <p>Введите период отбора</p>
            <DatePicker
            placeholder="Дата начала"
            format="DD.MM.YYYY"
            value={this.state[name]?.startDate}
            onChange={(value) => {
              this.setState({
                // $FlowFixMe ругается на [name]
                [name]: { ...this.state[name], startDate: value }
              });
            }} />

            <DatePicker
            placeholder="Дата окончания"
            format="DD.MM.YYYY"
            value={this.state[name]?.endDate}
            onChange={(value) => {
              this.setState({
                // $FlowFixMe ругается на [name]
                [name]: { ...this.state[name], endDate: value }
              });
            }} />

          </>
        }
        onConfirm={() => this.onConfirmCheck(name)}
        onCancel={() =>
        this.setState({
          // $FlowFixMe ругается на [name]
          [name]: {
            ...this.state[name],
            startDate: undefined,
            endDate: undefined
          }
        })
        }>

        <Button>{buttonText}</Button>
      </Popconfirm>);

  };

  render() {
    const { location } = this.props;
    const { data, totalCount, pageSize, page, loading, filter } = this.state;
    return (
      <>
        <Header
          left={<h1>Поездки</h1>}
          right={
          <>
              <ButtonsRow>
                {this.renderPrint(
                'printDeviationReport',
                'Отчет по расхождению данных системы и ПЛ'
              )}
              </ButtonsRow>
            </>
          } />

        <Section>
          <Filter
            filter={filter}
            cleanFilter={this.cleanFilter}
            applyFilter={this.applyFilter} />

          <Table
            columns={COLUMNS}
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            defaultOrderBy={'actualTimeAtStart'}
            fetch={this.fetchTrips}
            loading={loading}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }}
            data={data.map((item) => ({ ...item, key: item.id }))} />

        </Section>
      </>);

  }
}